module.exports = __webpack_public_path__ + "img/file.01523501.svg";